// gap-allocator is a computed endpoint, not a Directus collection, so the field

import { useQuery } from "@tanstack/react-query";
import { formatFields } from "../../utils/formatFields";
import { GAP_ALLOCATOR_ENTITY } from "./gapsOptions";
import { api } from "../../api/config";

// metadata comes from the endpoint itself instead of /fields/{entity}
export const useGapsFields = () => {
	const { data: rawFields, status } = useQuery({
		queryKey: [`${GAP_ALLOCATOR_ENTITY}-fields`],
		queryFn: async () => {
			const response = await api({ method: "GET", url: `/${GAP_ALLOCATOR_ENTITY}/fields` });
			return response.data.data;
		},
		staleTime: Infinity
	});

	if (!rawFields) return { formatedFields: [], status };

	const formatedFields = formatFields(rawFields).map((formatedField) => ({
		...formatedField,
		visible: true
	}));

	return { formatedFields, status };
};
